export default "__VITE_ASSET__CoG72K5c__"